import { render, staticRenderFns } from "./ListOrganisms.vue?vue&type=template&id=591db2e9"
import script from "./ListOrganisms.vue?vue&type=script&lang=js"
export * from "./ListOrganisms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports